var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticClass:"relation",attrs:{"disabled":_vm.disabled,"clearable":"","placeholder":"請選擇感情狀態"},model:{value:(_vm.relation),callback:function ($$v) {_vm.relation=$$v},expression:"relation"}},_vm._l((_vm.relationList),function(e){return _c('el-option',{key:e.value,attrs:{"value":e.value,"label":e.text}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }